import axios from 'axios';
import { mapState } from 'vuex';
import { redirectToApp, redirectToAppWithError } from '@/utils/appLoginHelper';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';

import iconProjects from '@/assets/images/product-icon-projects.svg';
import iconChat from '@/assets/images/product-icon-chat.svg';
import iconDesk from '@/assets/images/product-icon-desk.svg';
import iconCRM from '@/assets/images/product-icon-crm.svg';
import iconSpaces from '@/assets/images/product-icon-spaces.svg';

const icons = {
  projects: iconProjects,
  chat: iconChat,
  desk: iconDesk,
  crm: iconCRM,
  spaces: iconSpaces,
};

// @vue/component
export default {
  name: 'AppConsent',
  components: {
    PageHeader,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    app: {
      type: Object,
      default() {
        return {
          id: 0,
          ownerId: 0,
          code: '',
          clientId: '',
          scope: [],
          name: '',
          logo: '',
          url: '',
          dateCreated: null,
          dateUpdated: null,
          isValidated: true,
          description: '',
          publisher: { // could be null
            name: '',
            url: '',
            privacyUrl: '',
            termsUrl: '',
            logoUrl: '',
          },
        };
      },
    },
  },
  computed: {
    ...mapState({
      appInfo: (state) => state.login.appInfo,
      selectedAccount: (state) => state.login.selectedAccount,
    }),
    requestedScope() {
      if (this.appInfo.scope.length) {
        // openid is a scope, but not an app scope, so we filter it out if it's in the list
        return this.appInfo.scope.filter((scope) => scope.toLowerCase() !== 'openid');
      }
      // default to full app scope if none requested
      if (this.app.scope.length) {
        return this.app.scope;
      }
      return [];
    },
    showAppDetails() {
      return this.app.clientId; // we know it's a devportal app with a name
    },
    appIsLocal() {
      return (this.app.name !== 'localhost' && this.app.name !== '127.0.0.1');
    },
    logoUrl() {
      if (this.app.logo) return this.app.logo;
      if (this.app.publisher && this.app.publisher.logoUrl) return this.app.publisher.logoUrl;
      return '';
    },
  },
  methods: {
    onAllow() {
      const url = `${this.selectedAccount.installation.apiEndPoint || '/'}launchpad/v1/token/consent.json`;
      axios.post(url, { code: this.code }).then((response) => {
        redirectToApp(this.appInfo, response.data.code);
      }).catch(() => {
        redirectToAppWithError(this.appInfo, 'failed_to_consent', 'impossible to consent');
      });
    },
    onDeny() {
      redirectToAppWithError(this.appInfo, 'access_denied', 'user did not consent');
    },
    getAppName(productCode) {
      switch (productCode) { // eslint-disable-line
        case 'projects':
          return 'Teamwork';
        case 'desk':
          return 'Teamwork Desk';
        case 'chat':
          return 'Teamwork Chat';
        case 'crm':
          return 'Teamwork CRM';
        case 'spaces':
          return 'Teamwork Spaces';
      }
      return productCode;
    },
    getAppIcon(code) {
      if (!icons[code]) return '';
      return icons[code];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/AppConsent/AppConsent.js